export default __webpack_public_path__ + "static/media/clearp06.cc39e466.png";